import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { EmailTemplate } from "../../shared/EmailViewTemplate";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, IFilterResume } from "./Filter";
import { IResume } from "../../models/Resume";
import { EciSub } from "./EciSub";
import { Note } from "./Note";
import { SendEmail } from "./SendEmail";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// import DocxViewer from "./DocxViewer";

interface IProps {
    toast?: any
}

export interface ISearchedResumes {
    consultant_ID?: number,
    consultant_Name?: string,
    consultant_Job_Title?: string,
    consultant_Added_ByUser?: number,
    consultant_Home_No?: string,
    consultant_Cell_No?: string,
    total_Experience?: number,
    visa_Name?: string,
    current_Location?: string,
    relocation?: string,
    availability?: string,
    consultant_Resume_Path?: string,
    city_Name?: string,
    submittals?: string,
    state_Name?: string,
    state_Name2?: string,
    submitals1?: string,
    consultant_Email_ID?: string,
}

export const emptyFilter: IFilterResume = {
    query: "",
    email: "",
    job_Title: "",
    source: null,
    rate: null,
    salary: null,
    stateL: null,
    stateP: null,
    consultant_ID: null,
    home_No: "",
    cell_No: "",
    relocation: null,
    total_Experience: null,
    availability: null,
    fromDate: null,
    toDate: null,
    vendor_Company_ID: null,
    visa_ID: null,
    added: null,
    edited: null,
    submited: null,
    blocked: null,
    deleted: "",
    consID: null,
    phone: "",
    cell: "",
    companyName: {
        vendor_Company_ID: 0,
        vendor_Company_Name: ''
    },
    contactPersonEmail: "",
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISearchedResumes>, loading: boolean });
    const [reload, setReload] = useState<boolean>(false);
    //const [emailBodyModal, setEmailBodyModal] = useState({ open: false, data: {} } as { open: boolean, data: ISearchedResumes });
    const [ecisubModal, setEcisubModal] = useState({ open: false, data: 0 } as { open: boolean, data: number });
    const [noteModal, setNoteModal] = useState({ open: false, data: {} } as { open: boolean, data: ISearchedResumes });
    const [emailModal, setEmailModal] = useState({ open: false, data: [] } as { open: boolean, data: string[] });
    const [filters, setFilters] = useState(emptyFilter as IFilterResume);
    const [selectedConsultants, setSelectedConsultants] = useState<ISearchedResumes[] | null>(null);
    const [selectedAvailability, setSelectedAvailability] = useState<Array<string>>([]);
    const [selectedSource, setSelectedSource] = useState<Array<number>>([]);
    const [selectedVisa, setSelectedVisa] = useState<Array<number>>([]);
    const [selectedLocation, setSelectedLocation] = useState<Array<number>>([]);
    const [selectedPreffered, setSelectedPreffered] = useState<Array<number>>([]);
    const [selectedExp, setSelectedExp] = useState<Array<number>>([]);
    const [resume, setResume] = useState<any>(null);
    const [resEmail, setResEmail] = useState<string>("");
    const [resumeViewModal, setResumeViewModal] = useState({ open: false, data: {} } as { open: boolean, data: any });
    const [hiLtTxt, setHiLtTxt] = useState<string[]>([]);

    const dt = useRef<any>(null);

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                {/* <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => setReload(!reload)} /> */}
                {(selectedConsultants !== null && selectedConsultants.length > 0) && <Button label="Send Email" className="mt-2" onClick={sendEmail} />}
            </React.Fragment>
        );
    }

    const sendEmail = () => {
        if (selectedConsultants !== null && selectedConsultants.length != 0) {
            console.log('selectedConsultants', selectedConsultants);
            setEmailModal({ open: true, data: selectedConsultants.map(e => e.consultant_Email_ID ? e.consultant_Email_ID : "") });
        } else props.toast.current.show({ severity: 'error', detail: 'Please select consultant to send email', life: 3000 });
    }

    const rightToolbarTemplate = () => {
        return (
            <>
            </>
        );
    }

    const header = () => {
        return (
            <>
            </>
        );
    }

    const actionBodyTemplate = () => {
        return (
            <>
            </>
        );
    }

    const loadTableData = async () => {
        setHiLtTxt([]);
        setTableData({ tableData: tableData.tableData, loading: true });
        let mainFilter: any = filters;

        // if (mainFilter.stateL != null) mainFilter.stateL = mainFilter.stateL?.state_ID;
        // if (mainFilter.stateP != null) mainFilter.stateP = mainFilter.stateP?.state_ID;
        if (mainFilter.companyName != null) mainFilter.companyName = mainFilter.companyName?.vendor_Company_Name;

        const response = await Fetch("FindResume", "GET", null, `filters=${JSON.stringify(mainFilter)}`, props.toast);
        if (response) {
            const data: ISearchedResumes[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const onHide = () => {
        setEcisubModal({ open: false, data: 0 });
        setNoteModal({ open: false, data: {} });
        setEmailModal({ open: false, data: [] });
        setSelectedConsultants(null);
        setResumeViewModal({ open: false, data: {} });
    }

    const downloadResume = async (path: string, consultant_email_id: string) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/msword',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Resume_Mast/downloadByEmail"}?consultant_email_id=${consultant_email_id}`, params);
            if (response) {
                const data: any = await response.json();
                console.log(data);
                setResumeViewModal({ open: true, data: data });
                let newString = filters.query?.toLowerCase() || "";
                newString = newString.replace(/or/g, " ");
                newString = newString.replace(/and/g, " ");
                newString = newString.replace(/\(/g, " ");
                newString = newString.replace(/\)/g, " ");
                let stringArray = newString.split(" ").filter((e: string) => {
                    if (e.trim() != "") return e.trim();
                });
                setHiLtTxt(stringArray);
            }
            if (response.status === 200) {
                //const blob = await response.blob();
                //const href = window.URL.createObjectURL(blob);
                //console.log("href", href);
                //setResume(`${baseUrl}${"Resume_Mast/downloadByEmail"}?consultant_email_id=${consultant_email_id}`);
                // const a = document.createElement("a");
                // a.download = `${consultant_email_id.split(".com")[0]}.docx`;
                // a.href = href;
                // a.click();
                // a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const download = (rowData: ISearchedResumes) => {
        return (
            <p style={{ cursor: "pointer" }} className="text-blue-400 underline" onClick={() => {
                if (rowData.consultant_Email_ID && rowData.consultant_Email_ID) {
                    downloadResume('Consultant_Resume', rowData.consultant_Email_ID);
                }
            }}>{rowData.consultant_Name}</p>
        );
    };

    const RowECISUB = (rowData: ISearchedResumes) => {
        return (
            <p className="text-blue-400 underline" style={{ cursor: "pointer" }} onClick={() => (rowData.consultant_ID != null && rowData.consultant_ID != 0) ? setEcisubModal({ open: true, data: rowData.consultant_ID || 0 }) : props.toast.current.show({ severity: 'error', detail: 'Consultant Not Found', life: 3000 })}>{rowData.submittals}</p>
        );
    }

    useEffect(() => {
        if (filters.query !== "") {
            loadTableData();
        } else {
            setTableData({ tableData: [], loading: false });
        }
    }, [filters]);

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterResume) => setFilters(filters)} toast={props.toast}
                        selectedAvailability={selectedAvailability} setSelectedAvailability={setSelectedAvailability}
                        selectedSource={selectedSource} setSelectedSource={setSelectedSource}
                        selectedVisa={selectedVisa} setSelectedVisa={setSelectedVisa}
                        selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}
                        selectedPreffered={selectedPreffered} setSelectedPreffered={setSelectedPreffered}
                        selectedExp={selectedExp} setSelectedExp={setSelectedExp}
                    />
                </AccordionTab>
            </Accordion>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {/* {resume && <DocViewer
                documents={resume}
                // initialActiveDocument={resume[0]}
                pluginRenderers={DocViewerRenderers}
            />} */}
            {/* {resume != null && <DocxViewer file={resume} toast={props.toast} />} */}
            {/* <DocxViewer file={resume} toast={props.toast} /> */}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData}
                //lazy dataKey="id"
                emptyMessage="No Pages found."
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedConsultants}
                onSelectionChange={(e) => {
                    const value = e.value as ISearchedResumes[];
                    setSelectedConsultants(value);
                }}
            >
                {/* <Column field="consultant_ID" header="consultant_ID" sortable /> */}
                <Column selectionMode="multiple" />
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Consultant Name" sortable body={download} />
                <Column field="consultant_Email_ID" header="Email_ID" sortable />
                <Column field="consultant_Job_Title" header="Job_Title" sortable />
                {/* <Column field="consultant_Added_ByUser" header="consultant_Added_ByUser" sortable /> */}
                <Column field="consultant_Home_No" header="Home_No" sortable />
                <Column field="consultant_Cell_No" header="Cell_No" sortable />
                <Column field="total_Experience" header="Total Experience" sortable />
                <Column field="visa_Name" header="Visa Name" sortable />
                <Column field="current_Location" header="Current Location" sortable />
                <Column field="relocation" header="Relocation" sortable body={(rowData: ISearchedResumes) => <p style={{ color: rowData.relocation?.trim() === "No" ? "red" : "green" }}>{rowData.relocation}</p>} />
                {/* <Column field="availability" header="Availability" sortable /> */}
                <Column field="availability" header="Availability" sortable body={(rowData: ISearchedResumes) => <p style={{ color: Number(rowData.availability?.trim()) === 0 ? "red" : "green" }}>{Number(rowData.availability?.trim()) === 0 ? "No" : "Yes"}</p>} />
                {/* <Column field="consultant_Resume_Path" header="consultant_Resume_Path" sortable /> */}
                <Column field="city_Name" header="City Name" sortable />
                <Column field="submittals" header="SUB / ECI" sortable body={RowECISUB} />
                <Column field="state_Name" header="State Name" sortable />
                {/* <Column field="state_Name2" header="State Name2" sortable /> */}
                <Column field="submitals1" header="Submitals" sortable body={(rowData: ISearchedResumes) => <p style={{ color: rowData.submitals1?.trim() === "No" ? "red" : "green" }}>{rowData.submitals1}</p>} />
                <Column header="Note" body={(rowData: ISearchedResumes) => <p className="text-blue-400 underline" style={{ cursor: "pointer" }} onClick={() => setNoteModal({ open: true, data: rowData })}>Note</p>} />
            </DataTable>
            <Dialog visible={ecisubModal.open} style={{ width: '80vw' }} header="All SUB / ECI" className="p-fluid" maximizable onHide={onHide}>
                <EciSub toast={props.toast} consultant={ecisubModal.data} open={ecisubModal.open} />
            </Dialog>
            <Dialog visible={noteModal.open} style={{ width: '50vw' }} header="Add/Edit NOTE" className="p-fluid" maximizable onHide={onHide}>
                <Note toast={props.toast} data={noteModal.data} open={noteModal.open} />
            </Dialog>
            <Dialog visible={emailModal.open} style={{ width: '50vw' }} header="Add/Edit NOTE" className="p-fluid" maximizable onHide={onHide}>
                <SendEmail emailIDs={emailModal.data} open={emailModal.open} toast={props.toast} onHide={onHide} />
            </Dialog>
            <Dialog visible={resumeViewModal.open} style={{ width: '50vw' }} header="Add/Edit NOTE" className="p-fluid" maximizable onHide={onHide}>
                {resumeViewModal?.data?.resumeContent?.split("\r\n")?.map((e: string) => {
                    console.log(hiLtTxt);
                    return <p>{e.split(" ").map((el: string) => <span className="ml-1" style={hiLtTxt.includes(el.toLowerCase()) ? {backgroundColor: "yellow", color: "red"} : {}}>{el}</span>)}</p>
                    // return <p>{e}</p>
                })}
            </Dialog>
            {/* <Dialog visible={ecisubModal.open} style={{ width: '80vw' }} header="Email Body" className="p-fluid" maximizable onHide={onHide}>
                <p>{emailBodyModal.data.emailBody}</p>
                <EmailTemplate
                    email={emailBodyModal.data.email}
                    name={emailBodyModal.data.name}
                    emailDate={new Date(emailBodyModal.data.emailDate)}
                    subject={emailBodyModal.data.subject}
                    body={emailBodyModal.data.emailBody}
                />
            </Dialog> */}
        </>
    )
}